import React from 'react';
import FieldRow from './FieldRow';
import { RadioGroup } from '../Inputs';
import { RadioFieldProps } from './types';

export default function RadioField({ mask, unmask, ...props }) {
    return (
        <FieldRow {...props}>
            {({ field: { name, value, ...field }, form: { setFieldValue } }) => (
                <RadioGroup
                    {...field}
                    name={name}
                    value={unmask ? unmask(value) : value}
                    onChange={(e) => {
                        setFieldValue(name, mask ? mask(e.target.value) : e.target.value);
                    }}
                />
            )}
        </FieldRow>
    );
}

RadioField.propTypes = RadioFieldProps;
